import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/Button';
import { Headline } from 'components/Headline';
import { Loader } from 'components/Loader';
import { OrderModal } from 'components/OrderModal';
import { Warning } from 'components/Warning';

import { useList } from './List.hooks';
import * as S from './List.styles';

export function List(): React.ReactElement {
  const {
    listComponents,
    onDragEnd,
    isLoading,
    addItemsToOrder,
    isModalVisible,
    isModalVisibleSet,
    onOrderSubmit,
    isOrderLoading,
    getPDF,
    isPDFLoading,
    isStylePDFLoading,
    hasWarning,
  } = useList();
  const { t } = useTranslation();

  return (
    <Loader isLoading={isLoading}>
      <S.Container>
        {listComponents && listComponents.length > 0 ? (
          <>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="1">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {listComponents}

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>

            <S.BarContainer>
              <S.WarningContainer hidden={!hasWarning}>
                <Warning>{t('selection.removedProductNote')} </Warning>
              </S.WarningContainer>
              <S.ButtonWrapper>
                <Button
                  motive="actionRed"
                  scale="xs"
                  fontFamily="LFT Zeno"
                  onClick={() => addItemsToOrder()}
                >
                  {t('product.orderButton')}
                </Button>

                <Button
                  isLoading={isPDFLoading}
                  motive="actionRed"
                  scale="xs"
                  fontFamily="LFT Zeno"
                  onClick={() => getPDF()}
                >
                  {t('common.download')}
                </Button>

                <Button
                  isLoading={isStylePDFLoading}
                  motive="actionRed"
                  scale="xs"
                  fontFamily="LFT Zeno"
                  onClick={() => getPDF(true)}
                >
                  Style plan
                </Button>
              </S.ButtonWrapper>
            </S.BarContainer>
          </>
        ) : (
          <Headline textAlign="center" scale="xl3" isWrapped>
            {t('selection.emptyList')}
          </Headline>
        )}
      </S.Container>

      {isModalVisible ? (
        <OrderModal
          isLoading={isOrderLoading}
          onSubmit={onOrderSubmit}
          onClose={() => isModalVisibleSet(false)}
        />
      ) : undefined}
    </Loader>
  );
}
